module.exports = __webpack_public_path__ + "img/screen2.b7547ae.png";